export default {
    center: {
        recommendTitle1: '您好，歡迎查閱',
        recommendTitle2: '文檔',
        recommendTitle: '智能總結',
        helpTitle: '關於這篇文檔，我還可以幫你做：',
        recommendedQuestions: '推薦問題',
        recommend: '您好，歡迎來到',
        loadingTitle: '正在閱讀文件...',
        regenerate: '重新生成',
        assistantPlaceholder: '輸入"/"喚醒指令助手，輸入"{\'@\'}"對指定檔案提問',
        reference: '內容為AI生成僅供參考',
        knowledgeHeader: '強悍的知識庫 AI 助理',
        knowledgeHeaderTip: '基於大模型與文件對話，重塑文件查閱方式 ；洞悉海量紛繁知識文檔，輕輕鬆松閱讀理解',
        knowledgeTitle1: '文件精準解析',
        knowledgeTitle1Tip1: '精準辨識文件段落：處理複雜排版、內容跨頁等情況，確保原始資料精確度',
        knowledgeTitle1Tip2: '精準識別複雜表格：對合併單元格、複雜表格等情況精準識別，確保傳遞準確資訊',
        knowledgeTitle2: '多維度提問',
        knowledgeTitle2Tip1: '推薦提問：基於文件內容引導提問，基於答案拓展問題',
        knowledgeTitle2Tip2: '全庫提問：資訊整理，全域語意檢索，整庫內容總結',
        knowledgeTitle3: '可信，可溯源',
        knowledgeTitle3Tip1: '有據可依：答案依據來源，展示引用頁碼或互聯網鏈接地址',
        knowledgeTitle3Tip2: '一鍵溯源：點選溯源至原文且段落高亮',
        knowledgeDescLeft: '說明：支援解析 pdf、doc、docx、txt、md 格式的文件，字數限制',
        knowledgeDescRight: '百萬字，升級擴容 敬請期待',
        createKnowledge: '建立知識庫',
        editKnowledge: '編輯知識庫',
        clickUpload: '點選上傳',
        supportMore: '支援上傳一個或多個檔案',
        onlySupport: '僅支援上傳word/pdf/txt/md/ppt文件，',
        limit: '限制',
        chatLog: '對話記錄',
        stop: '停止生成',
        reopen: '即將為你開啟全新對話，一起探索新主題',
        hello: '您好，我是雅意·YaYi',
        answer: '你可以對我說：',
        change: '換一批',
        promptCheck: 'Prompt查看',
        addConversation: '新建對話',
        copy: '複製',
        copySuccess: '複製成功',
        startConnection: '建立連線中',
        endConnection: '關閉連線中',
        startRecord: '開始錄音',
        recording: '錄音中',
        textPlaceHolder: '有什麼問題儘管問我',
        allowFileType: '只允許上傳檔案的格式：',
        fileSizeMoreThan10: '檔案大小超出10M',
        selectedContent: '已選取內容：',
        unfold: '展開',
        doWhat: '要對這句話做點什麼呢？ ',
        welcome: '歡迎來到雅意YAYI平台',
        alreadyCharge: '系統已為您的帳戶充值',
       
        welcomeNew: '歡迎來到',
        welcomeTitle: '雅意暢語',
        welcomeTitle2: '智慧對話平台',
        newUserTip: '新使用者係統特別贈送',
        giveCount: '300',
        TipCount: '萬 tokens',
        alreadyChargeTip: '即時開啟你的AI創新體驗之旅～',

        yuan: '元！ ',
        fee: '費用說明',
        tips: '提示',
        token: '1 token 約等於 1.35 字',
        feeLess: '若費用不足，您可以進入',
        chargeManagement: '充值管理',
        goCharge: '去儲值費用。 ',
        gotIt: '我知道了',
        knowledgeName: '知識庫名稱',
        description: '簡介',
        icon: '圖示',
        knowledgePlaceholder: '請輸入知識庫名稱',
        knowledgeCountLimit: '知識庫名稱不能超過20個字元',
        createSuccess: '創建成功',
        editSuccess: '編輯成功',
        minimize: '最小化',
        closeTask: '關閉任務',
        total: '共',
        totalFile: '個檔案',
        succeeded: '已成功',
        fileCount: '個',
        failed: '失敗',
        taskRunning: '任務運行中',
        allTaskSuccess: '全部任務成功',
        portionTaskFail: '部分任務失敗',
        allTaskFail: '全部任務失敗',
        uploadStatus0: '解析中',
        uploadStatus1: '解析中',
        uploadStatus2: '上傳成功',
        uploadStatus3: '解析失敗',
        uploadStatus4: '上傳中',
        uploadStatus5: '上傳失敗',
        uploadStatus6: '容量不足',
        uploadStatus7: '解析為空',

        knowledgeTitle4: "多文檔格式",
        knowledgeList: "知識庫列表",
        placeholderSelect: '請選擇',
        placeholderKeyword: '請輸入知識庫名稱或標簽',
        public: "公開",
        publicPrivate: "對內公開",
        private: "個人",
        update: "更新",
        name: '名称',
        type: "類型",
        fileNumber: "文件數",
        fileSize: "文件大小",
        updateTime: "更新時間",
        words: "字",
        all: "全部",
    },
    aside: {
        fileCount: '個檔案',
        dirCount: '個資料夾',
        myKnowledge: '我的知識庫',
        keyword: '關鍵字',
        separateKeyword: '多個關鍵字用空格隔開',
        noData: '暫無資料',
        createImmediate: '立即建立',
        word: '字',
        upgrade: '升級擴容',
        deleteFileConfirm: '您確認要刪除該文件嗎？ 一旦刪除不可恢復',
        deleteFileAllConfirm: '您確認要刪除該目錄及其下的所有文件嗎？ 一旦刪除不可恢復',
        deleteAllFileConfirm: '您確認要刪除根目錄及其子目錄下的所有文件嗎？ 一旦刪除不可恢復',
        addDirectory: '新增目錄',
        uploadFile: '上傳檔案',
        edit: '編輯',
        delete: '刪除',
        rename: '重命名',
        moveTo: '移動至',
        moveHere: '移動到這裡',
        moveSuccess: '移動成功',
        deleteKnowledgeConfirm: '您確定要刪除目前知識庫嗎？ ',
        cancel: '取消',
        confirm: '確定',
        deleteKnowledgeLeft: '刪除知識庫後，知識庫內的所有檔案將立即被永久刪除，此操作不可撤銷，請輸入',
        deleteKnowledgeRight: '用以確認。 ',
        confirmNamePlaceholder: '請輸入知識庫名稱以確認',
        deleteSuccess: '刪除成功',
        inconsistentKnowledge: '知識庫名稱不一致',
        uploadImmediate: '立即上傳',
        limitless: '不限制',
        knowledgeCapacity: '知識庫容量',
        totalCapacity: '目前知識庫總容量',
        remainCapacity: '剩餘可用',
        deleteDirConfirm: '確認刪除此資料夾嗎？ 刪除後無法恢復',
        deleteFileConfirm2: '確認刪除此檔案嗎？ ',
        deleteDirTip: '刪除資料夾後，資料夾內所有檔案將會同步刪除，此操作不可撤銷。 ',
        deleteFileTip: '刪除後無法恢復',
        newFolder: '新建資料夾',
        onlyAllow: '只允許導入',
        fileType: '格式的檔案',
        fileSize200M: '檔案大小超出200M',
        maxFolder: '最多只能建立7層目錄',
        noResult: '搜尋無結果',
        changeKey: '換個關鍵字試試',
        descUpdateTime: '按更新時間倒序',
        ascUpdateTime: '依更新時間正序',
        descFileSize: '依檔案大小倒序',
        ascFileSize: '依檔案大小正序',
        nameSort: '依名稱排序',
        typeSort: '按類型排序',
        addURL: '加URL',
        save: '儲存',
        publicKnowledge:"公開知識庫",
    },
    bottom: {
        serviceAgreement: '服務協議',
        privacyPolicy: '隱私權政策'
    }
}